import { List } from "immutable";
import { clone } from "lodash";

import { ORIENTATION_ROW, TIMELINE_VIEW } from "../constants/identifiers";
import { ViewDisplayRecord } from "../types/immutableRecords/display/viewLayout/ViewDisplayRecord";
import { ViewLayoutRecord } from "../types/immutableRecords/model/appState/ViewLayoutRecord";
import { FilterRecord } from "../types/immutableRecords/model/data/FilterRecord";

const flattenViewChildren = layout => {
  let newLayout = layout;
  for (let i = 0; i < newLayout.children.length; i++) {
    if (typeof newLayout.children[i] != "string") {
      const added = newLayout.children.concat(newLayout.children[i].children);
      newLayout = newLayout.set("children", added);
      newLayout.children.splice(i, 1);
    }
  }
  return newLayout;
};

const removeView = (layout, viewId) => {
  let newLayout = layout;
  let i = newLayout.children.length;
  while (i--) {
    if (typeof newLayout.children[i] === "string") {
      if (newLayout.children[i] === viewId) {
        newLayout.children.splice(i, 1);
      }
    }
  }
  return newLayout;
};

// Make sure you really can't open non-timeline view types in Harvard readonly mode
const v3ToHarvardConverter = v3Data => {
  // Aeon open views + filters
  // Remove all views except timeline view
  let openViews = v3Data.appState ? clone(v3Data.appState.desktopOpenViews) : null;
  let layout = openViews.layout;
  layout = flattenViewChildren(layout);
  let filters = clone(v3Data.data.filters);
  let timelineViews = {};

  for (const viewId in openViews.byId) {
    const view = openViews.byId[viewId];
    if (view["viewType"] === TIMELINE_VIEW) {
      timelineViews[view.viewId] = view;
    } else {
      layout = removeView(layout, view.viewId);
      if (filters) {
        const position = filters.allIds.indexOf(view.viewId);
        if (position > -1) filters.allIds.splice(position, 1);
        delete filters.byId[view.viewId];
      }
    }
  }

  // Max of 3 views
  if (timelineViews.size > 3) {
    timelineViews = timelineViews.slice(0, 3);
  }

  openViews.byId = timelineViews;

  // If there are no open views left, add a timeline view
  if (!Object.keys(openViews.byId).length) {
    openViews.byId.primaryView = ViewDisplayRecord({
      viewId: "primaryView",
      viewType: TIMELINE_VIEW
    }).toJS();
    layout = ViewLayoutRecord({ children: List(["primaryView"]) }).toJS();
    filters.allIds = ["primaryView"];
    filters.byId = { primaryView: FilterRecord().toJS() };
  }
  layout.orientation = ORIENTATION_ROW;
  openViews.layout = layout;

  // Make sure the active view exists
  if (!openViews.byId[openViews.activeView]) {
    openViews.activeView = Object.keys(openViews.byId)[0];
  }

  v3Data.appState.desktopOpenViews = openViews;
  v3Data.data.filters = filters;

  return v3Data;
};

export default v3ToHarvardConverter;
